import React, { useCallback, useMemo } from 'react';
import { Select, SelectOption } from '@hugendubel/react-basic';
import { PointLimit, SearchService } from '../../../services/search-service';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';

const pointLimitOptions: ReadonlyArray<SelectOption<PointLimit>> = [
    { value: PointLimit.ALL, label: { id: 'page.Home.show.all' } },
    { value: PointLimit.AFFORDABLE, label: { id: 'page.Home.show.affordable' } },
];

export const SearchPointLimit: React.FC = () => {
    const { search } = useLocation();
    const navigate = useNavigate();
    const onChange = useCallback(
        (limit: PointLimit) => {
            navigate(SearchService.calculateUrl({ show: limit, page: 1 }));
        },
        [navigate]
    );

    const pointLimit: PointLimit = useMemo(
        () => (SearchService.getShowAllFromSearch(search) ? PointLimit.ALL : PointLimit.AFFORDABLE),
        [search]
    );

    return <Select className="label-hidden" value={pointLimit} onChange={onChange} options={pointLimitOptions} />;
};
